<template>
  <div class="box">
    <div class="tipbak"></div> 
    <div class="newsviews">
      <!-- <div class="tab">
        <router-link to="/">首页</router-link>>{{title}}<span v-if="childName">>{{ childName }}</span>
      </div> -->
      <div class="views">
        <!-- <div class="leftitem">
          <ul v-if="CategoryChildren&&CategoryChildren.length>0">
            <li v-for="(child,index) in CategoryChildren" :key="index"  :class="(child.uuid==childId)?'activeli':''" @click="changeArticleList(child.uuid,child.name)">
              <i :class="`leftIcon iconfont ${AllIcons[child.name]}`"></i>
               <p> {{ child.name }}</p>
            </li>
          </ul>
          <ul v-else>
            <li  class="activeli" >
              <i :class="`leftIcon iconfont ${AllIcons[title]}`"></i>
               <p> {{title }}</p>
            </li>
          </ul>
        </div> -->
        <div class="rightitem">
          <div v-if="arrPicNews.length>0">
            <el-carousel width="1300px" arrow="never" height="477px" :autoplay="true" class="swiper">
              <el-carousel-item v-for="( picNew , index) in arrPicNews" :key="index" width="1300px">
                <div class="swiperLeft" @click="$router.push(`/news/info/${picNew.plateid}/${picNew.uuid}`)">
                  <img :src="`${IP_TEST}/uploads/${picNew.picsrc}`" :alt="picNew.title" width="728" height="449">
                </div>
                <div class="swiperRight">
                  <h2 @click="$router.push(`/news/info/${picNew.plateid}/${picNew.uuid}`)">{{ picNew.title }}</h2>
                  <p>{{ picNew.description }}{{ picNew.description}}{{ picNew.description }}{{ picNew.description }}</p>
                  <p class="pageIndex">{{ picNew.addtime| filterdate }}</p>
                  <span @click="$router.push(`/news/info/${picNew.plateid}/${picNew.uuid}`)">详细信息</span>

                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="title">
            <ul v-if="CategoryChildren && CategoryChildren.length > 0">
              <li v-for="(child, index) in CategoryChildren" :key="index"  :class="(child.uuid == childId) ? 'activeli' : ''" @click="changeArticleList(child.uuid, child.name)">
                <!-- <i :class="`leftIcon iconfont ${AllIcons[child.name]}`"></i> -->
                 {{ child.name }}
              </li>
            </ul>
            <ul v-else>
              <li  class="activeli" >
                <!-- <i :class="`leftIcon iconfont ${AllIcons[title]}`"></i> -->
                 {{ title }}
              </li>
            </ul>
          </div>
          <!-- <div class="title">
            <h1>{{ childName?childName: title}}</h1>
          </div> -->
          <ul class="detail">
            <router-link tag="li" v-for="(item,index) in realList" :key="index" :to="`/news/info/${item.plateid}/${item.uuid}`">
              <div class="addtime">
                <span class="day">{{ item.addtime | dayfilter }}</span>
                <span class="year">{{ item.addtime | yearfilter }}</span>
              </div>
              <h4>{{item.title}}</h4>
              <p>{{ item.description }}</p>
            </router-link>
          </ul>
          <el-pagination
          background
            @current-change="toPage"
            :current-page="current"
            :page-size="6"
            layout="total, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { IP_TEST,AllIcons } from '@/config'
import { getNewsViews, getSearch } from '@/request/get'
import { getPicNews,getPlatePicNews } from '../request/get';
export default {
  name: "NewsViews",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId||'',
      childId: this.$route.params.childId||'',
      CategoryChildren:[],
      childName:"",
      current: 1,
      totalNum:0,
      list: [],
      realList: [],
      curChildId:"",
      arrPicNews:[],
      AllIcons,
      IP_TEST: IP_TEST
    }
  },
  filters: {
    filterdate(date) {
      return date.slice(0, 10);
    },
    filterPage(page) {
      if (page === 0) {
        return ""
      }
      return page
    },
     dayfilter(value) {
      return value.slice(8, 10);
    },
    yearfilter(value) {
      return value.slice(0, 7).replace(/-/g, '.');
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      if (this.plateId == "search") {
        return "搜索结果"
      }
      let arrs = plates.filter(item => item.uuid == this.plateId)
      if(arrs[0]&&arrs[0].CategoryChildren&&arrs[0].CategoryChildren.length>0&&this.childId)
      {
        let childarrs = arrs[0].CategoryChildren.filter(item => item.uuid == this.childId);
        this.childName = childarrs[0].name;
      }

      this.CategoryChildren =  arrs[0].CategoryChildren;
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    if (this.plateId == "search") {
      this.getSearch();
    } else {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.uuid == this.plateId)
      if(arrs[0]&&arrs[0].CategoryChildren&&arrs[0].CategoryChildren.length>0&&!this.childId)
      {
        this.childId = arrs[0].CategoryChildren[0].uuid
      }

      this.getNewsViews();
      this.getPicNews();
    }
  },
  mounted() {
    this.toTop();
  },
  methods: {
    async getSearch() {
      let result = await getSearch(this.$route.query.keyWords);
      result = result.data;
      this.totalNum = result.count;
      this.realList = result || [];
    },
    async changeArticleList(childId,name){
      this.childName = name;
      this.childId = childId;
        this.getNewsViews()
        this.getPicNews()
    },
    async getNewsViews() {
      let result = await getNewsViews(this.plateId, this.current,6,this.childId);
      this.totalNum = result.count;
      result = result.data;
      console.log("this.totalNum =",this.totalNum)
      this.realList = result || [];
    },
    async getPicNews(){
      let result = await getPlatePicNews(this.plateId,this.childId);
      result = result.data;
      this.arrPicNews = result || [];
    },
    async toPage(val) {
      this.current = val;
      let result = await getNewsViews(this.plateId, val,6,this.childId);
      result = result.data;
      this.realList = result || [];
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* background-color: #fff; */
}
.tipbak{
  margin: 0 auto;
  width: 1300px;
height: 140px;
background-image: url(/static/img/img/toubutiao.png);
background-repeat: repeat;
}
.newsviews{
  position: relative;
  width: 1300px;
  min-height: 964px;
  margin: 0 auto;
  overflow: hidden;
}
.newsviews>.pages{
  position: relative;
  margin-top:9px;
  width: 1300px;
  height: 36px;
  display: flex;
  justify-content: end;
}
.newsviews>.pages>li{
  margin-right: 23px;
  width: 34px;
  height: 34px;
  border: 1px solid #EDEDED;
  font-size: 14px;

  font-weight: 500;
  color: #999999;
  line-height: 34px;
  text-align: center;
}
.newsviews>.pages>li.up{
  background:url(/static/img/left.png) ;
  background-size: 34px 34px;
}
.newsviews>.pages>li.show{
  background: #306BCD;
  color: #FFFFFF;
}
.newsviews>.pages>li.next {
  background: url(/static/img/right.png);
  background-size: 34px 34px;
}
.newsviews .tab{
  margin: 0px 0 16px 0;
  width: 300px;
  height: 14px;
  font-weight: 500;
  font-size: 14px;
  font-weight: 400;
  color: #D9D9D9;
  line-height: 16px;
}
.newsviews .tab a{
  color: #D9D9D9;
}
.newsviews .views{
  min-height: 796px;
  padding-top: 19px;
  background-color: #fff;
  display: flex;
}
/* .newsviews .views .rightitem ul li{
  display: flex;
  justify-content: start;
} */
.newsviews .views .rightitem ul.detail li{
position: relative;
  width: 100%;
  height: 107px;
margin-bottom: 60px;
}
.newsviews .views .rightitem ul.detail li::after{
   position: absolute;
  top:137px;
  left:0;
  content: '';
  width: 1300px;
height: 1px;
background: #F7F7F7;
}
.newsviews .views .rightitem ul.detail li h4{
  position: absolute;
  top:10px;
  left:132px;
  width: 544px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 18px;
  word-break: break-all;
  /* display: -webkit-box; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

}
ul.detail li p{
   position: absolute;
  top:54px;
  left:130px;
  width: 1162px;
height: 40px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #999999;
line-height: 21px;
overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.newsviews .views .rightitem ul.detail li .addtime{
  position: relative;
 width: 107px;
height: 107px;
background: #FAFAFA;
font-size: 28px;
font-family: PingFang SC;
font-weight: bold;
color: #2E8EEB;
}
li .addtime .day{
   position: absolute;
  top:29px;
  left:31px;
}
li .addtime .year{
  position: absolute;
  top:73px;
  left:27px;
font-size: 14px;
}
.leftitem {
width: 183px;
display: inline-block;
}
.leftitem ul li{
  width: 127px !important;
  
  height: 72px;
  /* background: #F7FAFF; */
  /* border: 1px solid #0041BE; */
  background: #F8F8F8;
  border-radius: 20px 0px 20px 0px;
  text-align: center;
  padding: 23px 0;
  margin-bottom: 11px;
}
.leftitem ul li p{
  margin-top:15px;
  font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
}
.rightitem{
  width: 1300px;
}
.leftIcon{
  font-size:43px;
  
}
.el-pagination{
  float: right;
    /* margin-top: 21px;
    margin-right: 26px; */
}
.leftitem ul .activeli{
    background: #F7FAFF; 
   border: 1px solid #0041BE;
   color: #004FB7;
}
.swiperLeft{
  position: relative;
  width: 728px;
  display: inline-block;
}
.swiperRight{
  position: relative;
  box-sizing: border-box;
  width: 572px;
  overflow: hidden;
}
.swiperRight h2{
margin-top: 19px;
margin-left: 39px;
  font-size: 24px;
/* font-family: PingFang SC; */
font-weight: bold;
color: #333333;
line-height: 24px;
    height: 24px;
    overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.swiperRight p{
  position: relative;
  margin-left: 40px;
  width: 431px;
height: 240px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 30px;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
  margin-top:48px;
}
.swiperRight .pageIndex{
  position: relative;
  margin-left: 40px;
  margin-top:45px;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #2E8EEB;
line-height: 16px;
}
.swiperRight span{
  cursor: pointer;
  position: absolute;
  padding-right: 39px;
  right: 31px;
  bottom: 35px;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #2E8EEB;
line-height: 16px;
background-image: url(/static/img/img/jiantuoxinyou.png);
background-repeat: no-repeat;
background-position: right center;
}
.swiper{
  position: relative;
  box-sizing: border-box;
  padding-top: 25px;
  padding-left: 18px;
background: #F9FCFF;
}
.el-carousel__item{
  display: flex;
  
}
div >>>.el-carousel__indicators .is-active button{ 
  background: #2E8EEB;
}
div >>>.el-carousel__indicators button{ 
  width: 10px;
height: 10px;
background: #F7F7F7;
border-radius: 50%;
}
div >>>.el-carousel__indicators--horizontal{
  left: 40%;
  bottom:35px;
}
.newsviews .views .rightitem .title ul{
  position: relative;
  margin: 49px 0 46px;
  width: 1300px;
  height: 50px;
  border-bottom: 2px solid #2E8EEB;
}
.newsviews .views .rightitem .title ul li{
  cursor: pointer;
  float: left;
  padding: 0 20px;
  height: 50px;
font-size: 24px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 50px;
}
.newsviews .views .rightitem .title ul li.activeli{

background: #2E8EEB;

color: #FFFFFF;
}
div >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2E8EEB;

}
</style>
